import { PAGE_LINKS } from '@/helpers/commonConsts'
import { adminService } from '@/services/adminService'
import { Spin } from 'antd'
import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router'

interface AuthRendererProps {
  children: React.ReactNode
  requiredPermission?: string // 可选的权限标识（对应菜单 key）
}

export const AuthRenderer = observer((p: AuthRendererProps) => {
  const [loading, setLoading] = useState(true)
  const location = useLocation()

  useEffect(() => {
    adminService.getUserInfo(true).finally(() => setLoading(false))
  }, [])

  if (loading) {
    return (
      <div
        style={{
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Spin spinning={true} />
      </div>
    )
  }

  // 如果用户未登录，重定向到登录页
  if (adminService.userData === null) {
    return <Navigate to={PAGE_LINKS.adminLogin} state={{ from: location.pathname }} replace />
  }

  // 如果有权限要求，检查用户是否有该权限
  if (p.requiredPermission) {
    const isSuperAdmin = adminService.userData.isSuperAdmin === 1
    // 超级管理员拥有所有权限，或者用户的 authorizedResources 包含该权限标识
    const hasPermission = 
      isSuperAdmin || 
      adminService.userData.authorizedResources.includes(p.requiredPermission)
    
    if (!hasPermission) {
      // 无权限，重定向到工作台或无权限提示页
      console.warn(`用户无权限访问：${p.requiredPermission}`)
      return <Navigate to={PAGE_LINKS.adminWorkbench} replace />
    }
  }

  return p.children
})
